import React, { useCallback, useEffect, useState } from "react";
import Layout from "../../Layout";
import * as RB from "react-bootstrap";
import DataTable from "react-data-table-component";
import Swal from "sweetalert2";
import EditIcon from "@mui/icons-material/Edit";
import { Delete } from "@mui/icons-material";
import * as utils from "../../Utils/comman";
import { Edit2, Trash } from "iconsax-react";
import { Link } from "react-router-dom";
import { useSelector } from "react-redux";
import CustomPagination from "../../Utils/CustomPagination";
import { debounce, values } from "lodash";
import Select from "react-select";

function SubCategorys() {
  const [subCategory, setSubCategory] = useState("");
  const [isActive, setIsActive] = useState("");
  const [validated, setValidated] = useState(false);
  const [isSubmit, setIsSubmit] = useState(false);
  const [subCat, setSubCategoryList] = useState([]);
  const [isEdit, setIsEdit] = useState([]);
  const [editId, setEditId] = useState("");
  const [page, setPage] = useState(1);
  const countPerPage = 10;
  const [categoryList, setCategoryList] = useState([]);
  const [cat, setcat] = useState(null);
  const [subCate, setsubcat] = useState("");
  const [filterText, setFilterText] = useState("");

  const statusList = [
    { id: "", name: "Select an option..." },
    { id: "1", name: "Active" },
    { id: "0", name: "Inactive" },
  ];
  const primaryMenuRes = useSelector(
    (state) => state?.primaryMenu?.primaryMenu?.permissions
  );

  const columns = [
    {
      name: "Category",
      selector: (row) => row.category_name,
    },
    {
      name: "Sub Category",
      selector: (row) => row.subcategory_name,
    },
    {
      name: "Status",
      selector: (row) => (row.status == "1" ? "Active" : "InActive"),
    },
    {
      name: "Action",
      cell: (row) => (
        <>
          {utils.hasPermission(
            primaryMenuRes,
            "Sub Category",
            "subcategory.edit"
          ) && (
            <RB.Button className="btn-flat" onClick={() => handleEdit(row)}>
              <Edit2 />
            </RB.Button>
          )}
          &nbsp;
          {utils.hasPermission(
            primaryMenuRes,
            "Sub Category",
            "subcategory.delete"
          ) && (
            <RB.Button className="btn-flat" onClick={() => showDelete(row)}>
              <Trash />
            </RB.Button>
          )}
        </>
      ),
    },
  ];
  const customStyles = {
    menu: (provided) => ({
      ...provided,
      zIndex: 9999,
    }),
  };
  useEffect(() => {
    getCat();
  }, [page]);

  useEffect(() => {
    getSubCat();
  }, [page, filterText]);

  const getCat = () => {
    utils
      .callAPI("get", `/rawmaterial/category/list`)
      .then((res) => {
        if (typeof res !== "undefined") {
          const filteredCategories = res?.result?.filter(
            (category) => category.status === "1"
          );
          setCategoryList(filteredCategories);
        } else {
          setCategoryList([]);
        }
      })
      .catch((err) => {
        setCategoryList([]);
      });
  };

  const getSubCat = () => {
    utils
      .callAPI(
        "get",
        `/rawmaterial/subcategory/list?page=${page}&per_page=${countPerPage}&search=${filterText}`
      )
      .then((res) => {
        if (typeof res !== "undefined") {
          setSubCategoryList(res);
        } else {
          setSubCategoryList([]);
        }
      })
      .catch((err) => {
        setSubCategoryList([]);
      });
  };

  const handleEdit = useCallback((row) => {
    setIsEdit(true);
    setsubcat(row.subcategory_name);
    setcat({
      value:row.category_id,
      label:row?.category_name
    });
    setIsActive(row.status);
    setEditId(row.id);
  }, []);

  const showDelete = useCallback((row) => {
    Swal.fire({
      title: "Are you sure?",
      text: "Once deleted, you will not be able to recover this data!",
      icon: "warning",
      showDenyButton: true,
      confirmButtonText: "Yes, delete it!",
    }).then((result) => {
      if (result.isConfirmed) {
        utils
          .callAPI("get", `/rawmaterial/subcategory/delete?id=${row.id}`)
          .then((res) => {
            if (typeof res !== "undefined") {
              getSubCat();
            }
          })
          .catch((err) => {});
      }
    });
  }, []);

  const handleCat = (selectedOption) => {
    setcat(selectedOption);
  };

  const handlesubcat = (event) => {
    setsubcat(event.target.value);
    // getsubCatByCat()
  };

  const handleStatusChange = (event) => {
    setIsActive(event.target.value);
  };

  const handleSubmit = (e) => {
    e.preventDefault();
    const form = e.currentTarget;

    if (form.checkValidity() === false) {
      e.stopPropagation();
      setValidated(true);
    } else {
      setIsSubmit(true);
    }
  };

  useEffect(() => {
    if (isSubmit) {
      var bodyFormData = new FormData();
      if (isEdit) {
        bodyFormData.append("id", editId);
      }
      bodyFormData.append("category_id", cat?.value);
      bodyFormData.append("subcategory_name", subCate);
      bodyFormData.append("status", isActive);

      utils
        .callAPI("post", `/rawmaterial/subcategory/save`, bodyFormData)
        .then((res) => {
          if (typeof res !== "undefined") {
            setIsSubmit(false);
            getSubCat();
            setSubCategory("");
            setIsActive("");
            setcat("");
            setsubcat("");
            setIsActive("");
          } else {
            setIsSubmit(false);
          }
        })
        .catch((err) => {
          setIsSubmit(false);
        });
    }
  }, [isSubmit]);

  const handleClear = () => {
    setcat("");
    setsubcat("");
    setIsActive("");
    setIsEdit(false);
    setEditId("");
  };

  const handlePageChange = (newPage) => {
    setPage(newPage);
  };
  const handleFilterChange = debounce((value) => {
    setFilterText(value);
    setPage(1);
  }, 500);
  return (
    <Layout>
      <div className="main-content">
        <section className="section">
          <div className="section-header">
            <h1>Sub Category</h1>
          </div>
          <div className="section-body">
            <RB.Card className="">
              <RB.Card.Body>
                <RB.Row>
                  {utils.hasPermission(
                    primaryMenuRes,
                    "Sub Category",
                    "subcategory.create"
                  ) && (
                    <RB.Col md={4}>
                      <RB.Card className="shadow-1">
                        <RB.Card.Body>
                          <RB.Form
                            noValidate
                            validated={validated}
                            onSubmit={handleSubmit}
                          >
                            <div className="mb-3">
                              <Select
                                id="category"
                                name="category"
                                options={categoryList.map((cat) => ({
                                  value: cat.id,
                                  label: cat.category_name,
                                }))}
                                value={cat || null}
                                onChange={handleCat}
                                placeholder="Select Category..."
                                isSearchable
                                styles={customStyles}
                              />
                            </div>

                            <div className="mb-3">
                              <RB.FloatingLabel
                                controlId="subcategory"
                                label="Sub Category"
                                className="floating-label-fancy"
                              >
                                <RB.Form.Control
                                  type="text"
                                  placeholder="Enter Sub Category"
                                  value={subCate}
                                  onChange={handlesubcat}
                                  required
                                />
                                <RB.Form.Control.Feedback type="invalid">
                                  Please enter sub category.
                                </RB.Form.Control.Feedback>
                              </RB.FloatingLabel>
                            </div>

                            <div className="mb-3">
                              <RB.FloatingLabel
                                controlId="isActive"
                                label="Status"
                                className="floating-label-fancy"
                              >
                                <RB.Form.Select
                                  value={isActive}
                                  onChange={handleStatusChange}
                                  required
                                >
                                  {statusList.map((status) => (
                                    <option key={status.id} value={status.id}>
                                      {status.name}
                                    </option>
                                  ))}
                                </RB.Form.Select>
                                <RB.Form.Control.Feedback type="invalid">
                                  Please select status.
                                </RB.Form.Control.Feedback>
                              </RB.FloatingLabel>
                            </div>
                            <div className="d-flex align-items-center gx-3">
                              <div className="text-start">
                                <RB.Button type="submit" variant="primary">
                                  Submit
                                </RB.Button>
                              </div>
                              <div>
                                <Link
                                  className="text-underline ms-3"
                                  //	type="reset"
                                  //variant="primary"
                                  onClick={handleClear}
                                >
                                  {"Clear"}
                                </Link>
                              </div>
                            </div>
                          </RB.Form>
                        </RB.Card.Body>
                      </RB.Card>
                    </RB.Col>
                  )}
                  {utils.hasPermission(
                    primaryMenuRes,
                    "Sub Category",
                    "subcategory.view"
                  ) && (
                    <RB.Col md={8}>
                      <RB.Card className="shadow-1">
                        <RB.Card.Body>
                          <RB.Row>
                            <RB.Col md={12} className="mb-3">
                              <RB.Form.Control
                                type="text"
                                placeholder="Search By Sub Category..."
                                onChange={(e) =>
                                  handleFilterChange(e.target.value)
                                }
                              />
                            </RB.Col>
                            <RB.Col md={12}>
                              <DataTable
                                columns={columns}
                                data={subCat.result}
                                highlightOnHover
                                responsive
                                pagination
                                paginationServer
                                paginationTotalRows={subCat.total}
                                paginationPerPage={countPerPage}
                                paginationComponentOptions={{
                                  noRowsPerPage: true,
                                }}
                                paginationComponent={() => (
                                  <CustomPagination
                                    currentPage={page}
                                    totalRows={subCat.total}
                                    rowsPerPage={countPerPage}
                                    onPageChange={handlePageChange}
                                  />
                                )}
                                striped
                                onChangePage={(page) => setPage(page)}
                                persistTableHead
                                customStyles={{
                                  head: {
                                    style: {
                                      fontSize: "0.875rem", // Adjust the font size as needed
                                      fontWeight: "bold", // Adjust the font weight as needed
                                    },
                                  },
                                }}
                              />
                            </RB.Col>
                          </RB.Row>
                        </RB.Card.Body>
                      </RB.Card>
                    </RB.Col>
                  )}
                </RB.Row>
              </RB.Card.Body>
            </RB.Card>
          </div>
        </section>
      </div>
    </Layout>
  );
}

export default SubCategorys;
